// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"554":"f31a8175","960":"5beb810c"}[chunkId] + ".js";
};